import React, { useEffect, useState } from 'react';
import useMobile from '../hooks/useIsMobile';
import axios from 'axios';
import { format } from 'date-fns';

const NewsPage = () => {
  const [news, setNews] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const isMobile = useMobile();

  const getNews = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(`http://api.kwiecinscy.com.pl/api/news`);
      setNews(res.data.data);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getNews();
  }, []);

  return (
    <div className="min-h-[calc(100dvh-280px)] container">
      <h1 className="mt-24 text-center uppercase pb-4 mb-4 border-b-2 border-black">
        Aktualności
      </h1>
      <div className="flex flex-col gap-8 pt-4">
        {news.map((article) => {
          return (
            <article
              key={article.id}
              className="flex flex-col items-center md:flex-row gap-4 border-b pb-8 border-black"
            >
              <img
                src={article.image}
                alt={article.name}
                className="object-cover w-auto md:max-w-[300px] max-h-[300px] rounded-2xl"
              />
              <div className="flex flex-col gap-4 mt-2">
                <h3 className="text-[#0e3a1b]">{article.name}</h3>
                <span className="w-full text-base">
                  {format(article.created_at, 'dd.MM.yyyy')}
                </span>
                <span className="w-full">{article.description}</span>
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
};

export default NewsPage;
